import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BillingLockService, isBillingLockedBody } from '../../core/payment-popup/billing-lock.service';

/**
 * Switches the shell into the "Account suspended" screen when any API answers
 * 402 `{ code: 'billing_locked' }` (ZEY-3046). The error is always rethrown unchanged so
 * call sites behave exactly as before; other 402s (e.g. plain-text "Tenant is inactive.")
 * are left alone.
 */
@Injectable()
export class BillingLockInterceptor implements HttpInterceptor {
  constructor(private billingLock: BillingLockService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 402) {
          this.inspect(error.error);
        }
        return throwError(() => error);
      })
    );
  }

  private inspect(body: unknown): void {
    // Blob/arraybuffer requests (file downloads) hand back the raw body.
    if (typeof Blob !== 'undefined' && body instanceof Blob) {
      body.text().then((text) => {
        if (isBillingLockedBody(text)) this.billingLock.lock();
      }).catch(() => undefined);
      return;
    }
    if (body instanceof ArrayBuffer) {
      if (isBillingLockedBody(new TextDecoder().decode(body))) this.billingLock.lock();
      return;
    }
    if (isBillingLockedBody(body)) this.billingLock.lock();
  }
}
